import React from 'react';
import { SlideOver } from './primitives';

const EditBroadcastSlideOver = ({ editingBroadcast, editDraft, setEditDraft, onSave, onClose }) => (
  <SlideOver
    title='Edit scheduled broadcast'
    subtitle={editingBroadcast.title}
    onClose={onClose}
    className='list'
  >
    <div className='nb-edit-broadcast'>
      <label className='nb-edit-label'>Message</label>
      <textarea
        className='nb-edit-textarea'
        value={editDraft.message}
        onChange={e => {
          const { value } = e.target;
          setEditDraft(d => ({ ...d, message: value }));
        }}
      />
      <label className='nb-edit-label'>Send at</label>
      <div className='nb-edit-when'>
        <input
          type='date'
          value={editDraft.date}
          onChange={e => {
            const { value } = e.target;
            setEditDraft(d => ({ ...d, date: value }));
          }}
        />
        <input
          type='time'
          value={editDraft.time}
          onChange={e => {
            const { value } = e.target;
            setEditDraft(d => ({ ...d, time: value }));
          }}
        />
        <span>ET</span>
      </div>
      <p className='nb-edit-hint'>
        Filters were captured when this broadcast was scheduled. To change the cohort, cancel this broadcast and create a new one.
      </p>
      <div className='nb-edit-actions'>
        <button className='nb-edit-cancel' onClick={onClose}>
          Cancel
        </button>
        <button className='nb-edit-save' onClick={onSave}>
          Save changes
        </button>
      </div>
    </div>
  </SlideOver>
);

export default EditBroadcastSlideOver;
